import React from 'react'
import SEO from '../seo/SEO'; // Import SEO Component
import { BecomePublisherSEOData } from '../seo/BecomePublisherSEO'; // Import Data

export default function BecomePublisher() {
    return (
        <>
            {/* Inject SEO Tags & Schema */}
            <SEO {...BecomePublisherSEOData} />

            <section className="py-5">
                <div className="container px-5 my-5">
                    <div className="row gx-5 justify-content-center">
                        <div className="col-lg-12 col-xl-12">
                            <div className="text-center">
                                <h2 className="fw-bolder">നിങ്ങളുടെ പുസ്തകം ഞങ്ങളിലൂടെ പ്രസിദ്ധീകരിക്കൂ</h2>

                                <p className="lead fw-normal text-muted mb-5">
                                    ഉയിർമൊഴി പ്രസാധനം പുതിയ എഴുത്തുകാരെയും, വളർച്ചയുടെ പാതയിലുള്ള
                                    സാഹിത്യകാരെയും, അവരുടെ കൃതികളെ ലോകവുമായി പങ്കിടാൻ ആഗ്രഹിക്കുന്ന
                                    എല്ലാവരെയും സസന്തോഷം സ്വാഗതം ചെയ്യുന്നു. ഒരു പുസ്തകം എഴുതുന്നത് ഒരു സ്വപ്നമാണെങ്കിലും,
                                    അതിനെ പ്രസിദ്ധീകരിച്ച് വായനകാരിലേക്ക് എത്തിക്കുന്നത് അതിനേക്കാൾ വലിയൊരു യാത്രയാണ്.
                                    ആ യാത്രയിലെ ഓരോ ഘട്ടത്തിലും നിങ്ങളുടെ കൂടെ നിൽക്കുക എന്നതാണ് ഉയിർമൊഴിയുടെ
                                    ലക്ഷ്യം.
                                </p>

                                <p className="lead fw-normal text-muted mb-5">
                                    <strong>കൈയെഴുത്ത് തയ്യാറാക്കുന്നതിൽ നിന്നു തുടങ്ങി:</strong><br />
                                    എഡിറ്റിംഗ്, പ്രൂഫ്‌റീഡിംഗ്, കവർ ഡിസൈൻ, ടൈപ്പ്‌സെറ്റിംഗ്, ISBN നേടൽ,
                                    പ്രിന്റിംഗ്, വിതരണം, ഓൺലൈൻ വിൽപ്പന, മാർക്കറ്റിംഗ് എന്നിവയുടെ മുഴുവൻ
                                    നടപടികളും ഞങ്ങളുടെ പരിചയസമ്പത്ത് ഉപയോഗിച്ച് സുഗമമാക്കുന്നു.
                                </p>

                                <p className="lead fw-normal text-muted mb-5">
                                    <strong>നിങ്ങളുടെ രചനയുടെ തരം എന്തുമാകട്ടെ —</strong><br />
                                    നോവൽ, കഥാസമാഹാരം, കവിത, ആത്മകഥ, ബാലസാഹിത്യം, പഠനസാഹിത്യം,
                                    ഗവേഷണഗ്രന്ഥം, ഹാൻഡ്‌ബുക്ക്, ആത്മീയത, ശാസ്ത്രം, ചരിത്രം,
                                    അല്ലെങ്കിൽ വ്യക്തിഗത പദ്ധതി — എല്ലാത്തിനും പ്രത്യേക പിന്തുണ
                                    ഞങ്ങൾ നൽകുന്നു.
                                </p>

                                <p className="lead fw-normal text-muted mb-5">
                                    <strong>പ്രസിദ്ധീകരണം കഴിഞ്ഞാൽ പോലും യാത്ര അവസാനിക്കില്ല.</strong><br />
                                    വായനക്കാരിലേക്ക് പുസ്തകം എത്തിക്കുന്നത് ഏറ്റവും നിർണായക ഘട്ടമാണ്.
                                    ഉയിർമൊഴി നിങ്ങളുടെ പുസ്തകത്തെ Amazon, Flipkart പോലുള്ള പ്രമുഖ
                                    ഓൺലൈൻ പ്ലാറ്റ്ഫോമുകളിലും, ഞങ്ങളുടെ സ്വന്തം Direct Purchase
                                    സംവിധാനത്തിലൂടെ WhatsApp മുഖേനയും എത്തിക്കുന്നു. ഇതുവഴി ലോകമെമ്പാടുമുള്ള
                                    വായനക്കാർക്ക് നിങ്ങൾയുടെ കൃതി എളുപ്പത്തിൽ ലഭ്യമാകും.
                                </p>

                                <p className="lead fw-normal text-muted mb-5">
                                    നിങ്ങളുടെ രചനയെ ഒരു മനോഹര പുസ്തകമായി മാറ്റാൻ ഇന്ന് തന്നെ
                                    ഞങ്ങളെ ബന്ധപ്പെടൂ. നിങ്ങളുടെ വാക്കുകൾക്ക് ലോകത്ത് എത്തേണ്ട വിലയുണ്ട് —
                                    അതിനെ സാക്ഷാത്കരിക്കാൻ ഉയിർമൊഴി നിങ്ങളോടൊപ്പം.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}